<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc1"><a href="#/xhtml/05_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="toc2"><a href="#/xhtml/06_Chapter01"><span class="bold"><span class="space">Chapter 1</span></span> Principate to Dominate: Empire in Transition</a></h2>
<h2 class="toc2"><span href="#/xhtml/07_Chapter02" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 2</span></span> The Roman Military in Transition</span></h2>
<h2 class="toc2"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 3</span></span> Roman Britain and the ‘Crisis of the 3rd Century’</span></h2>
<h2 class="toc2"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 4</span></span> Enter Carausius</span></h2>
<h2 class="toc2"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 5</span></span> The North Sea Empire</span></h2>
<h2 class="toc2"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample"><span class="bold"><span class="space">Chapter 6</span></span> Constantius Chlorus: Nemesis</span></h2>
<h2 class="toc3"><span href="#/xhtml/12_Conclusion" title="Link target outside of Sample"><em class="italic">Conclusion</em></span></h2>
<h2 class="toc4"><span href="#/xhtml/13_References" title="Link target outside of Sample"><em class="italic">List of References and Bibliography</em></span></h2>
<h2 class="toc4"><span href="#/xhtml/14_Platesection" title="Link target outside of Sample">Platesection</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?88902a94